var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          ref: "modalManageVisits",
          attrs: {
            "hide-footer": "",
            size: "lg",
            id: "modalManageVisits",
            title: "Resumen visitas"
          },
          on: {
            hidden: function($event) {
              _vm.$parent.closeManageVisits()
            }
          }
        },
        [
          _c(
            "b-form",
            [
              _c(
                "b-row",
                [
                  _c("b-col", { attrs: { cols: 12 } }, [
                    _c(
                      "div",
                      [
                        _c(
                          "b-form-checkbox",
                          {
                            attrs: {
                              id: "checkbox1",
                              value: true,
                              "unchecked-value": false
                            },
                            model: {
                              value: _vm.inputs.showWeeks.value,
                              callback: function($$v) {
                                _vm.$set(_vm.inputs.showWeeks, "value", $$v)
                              },
                              expression: "inputs.showWeeks.value"
                            }
                          },
                          [
                            _vm._v(
                              "\n              Seleccionar semanas\n            "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "mt-3" },
                [
                  _vm.inputs.showWeeks.value === false
                    ? _c(
                        "b-col",
                        { attrs: { cols: 2 } },
                        [
                          _vm._v("\n          Fecha inicio\n          "),
                          _c("datepicker", {
                            attrs: {
                              "bootstrap-styling": true,
                              format: _vm.customFormatter,
                              name: "dateStart"
                            },
                            model: {
                              value: _vm.inputs.dateStart.value,
                              callback: function($$v) {
                                _vm.$set(_vm.inputs.dateStart, "value", $$v)
                              },
                              expression: "inputs.dateStart.value"
                            }
                          }),
                          _vm._v(" "),
                          _vm.checkStartDate
                            ? _c("span", { staticClass: "error" }, [
                                _vm._v(
                                  "La fecha de inicio es mayor que la fecha fin"
                                )
                              ])
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.inputs.showWeeks.value === false
                    ? _c(
                        "b-col",
                        { attrs: { cols: 2 } },
                        [
                          _vm._v("\n          Fecha fin\n          "),
                          _c("datepicker", {
                            attrs: {
                              "bootstrap-styling": true,
                              format: _vm.customFormatter,
                              name: "dateEnd"
                            },
                            model: {
                              value: _vm.inputs.dateEnd.value,
                              callback: function($$v) {
                                _vm.$set(_vm.inputs.dateEnd, "value", $$v)
                              },
                              expression: "inputs.dateEnd.value"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.inputs.showWeeks.value === true
                    ? _c(
                        "b-col",
                        { attrs: { cols: 2 } },
                        [
                          _vm._v(
                            "\n          Fecha inicio (semana)\n          "
                          ),
                          _c("b-form-select", {
                            staticClass: "mb-3",
                            attrs: {
                              options: _vm.inputs.dateStart.availableWeeks,
                              size: "sm"
                            },
                            model: {
                              value: _vm.inputs.dateStart.value,
                              callback: function($$v) {
                                _vm.$set(_vm.inputs.dateStart, "value", $$v)
                              },
                              expression: "inputs.dateStart.value"
                            }
                          }),
                          _vm._v(" "),
                          _vm.checkStartDate
                            ? _c("span", { staticClass: "error" }, [
                                _vm._v(
                                  "La fecha de inicio es mayor que la fecha fin"
                                )
                              ])
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.inputs.showWeeks.value === true
                    ? _c(
                        "b-col",
                        { attrs: { cols: 2 } },
                        [
                          _vm._v("\n          Fecha fin (semana)\n          "),
                          _c("b-form-select", {
                            staticClass: "mb-3",
                            attrs: {
                              options: _vm.inputs.dateEnd.availableWeeks,
                              size: "sm"
                            },
                            model: {
                              value: _vm.inputs.dateEnd.value,
                              callback: function($$v) {
                                _vm.$set(_vm.inputs.dateEnd, "value", $$v)
                              },
                              expression: "inputs.dateEnd.value"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { cols: 3 } },
                    [
                      _vm._v("\n          Grupo\n          "),
                      _c("b-form-select", {
                        staticClass: "mb-3",
                        attrs: {
                          options: _vm.inputs.group.options,
                          size: "sm"
                        },
                        model: {
                          value: _vm.inputs.group.value,
                          callback: function($$v) {
                            _vm.$set(_vm.inputs.group, "value", $$v)
                          },
                          expression: "inputs.group.value"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { cols: 3 } },
                    [
                      _vm._v("\n          Distribuidora\n          "),
                      _c("multiselect", {
                        attrs: {
                          placeholder: "Todas",
                          "deselect-label": "Click o enter para deseleccionar",
                          "select-label": "Click o enter para seleccionar",
                          options: _vm.inputs.distributor.options,
                          multiple: true,
                          "close-on-select": false,
                          "clear-on-select": false,
                          "preserve-search": true,
                          label: "name",
                          "track-by": "name",
                          "preselect-first": true
                        },
                        model: {
                          value: _vm.inputs.distributor.value,
                          callback: function($$v) {
                            _vm.$set(_vm.inputs.distributor, "value", $$v)
                          },
                          expression: "inputs.distributor.value"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { cols: 2 } },
                    [
                      _vm._v("\n           \n          "),
                      _c(
                        "b-button",
                        {
                          attrs: {
                            size: "lg",
                            block: true,
                            variant: "primary"
                          },
                          on: { click: _vm.submitFilters }
                        },
                        [_vm._v("Buscar")]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { cols: 12 } },
                    [
                      _vm.showManageVisitsResultsPopup
                        ? _c("ManageVisitsResults", {
                            attrs: {
                              inputs: _vm.inputs,
                              data: _vm.resultsData,
                              group: this.inputs.group.value
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Layout/CommercialManagement/ManageVisits.vue?vue&type=template&id=2a6dc10c&
// module id = null
// module chunks = 